import { mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Dialog, Grid, MenuItem, Stack, TextField, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { useSnackbar } from '../../../components/context/SnackbarContext';
import useAxios from '../../../hooks/useAxios';
import { useLoader } from "../../../components/context/LoaderContext";
import { Navigate } from "react-router-dom";



function CreateNewContactDialog({ open, onClose, handleReloadFunc, account_id, salutationList, contactID, handleReloadParentFunc }) {
    const axiosInstance = useAxios();
    const { showSnackbar } = useSnackbar();
    const { showLoader, hideLoader } = useLoader();

    const [contactData, setContactData] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState();

    const validationSchema = yup.object().shape({
        first_name: yup.string().trim('First name cannot include space').strict(true).min(2, 'Must be at least 2 characters').max(50, 'Must be at most 50 characters').required('Enter first name'),
        last_name: yup.string().trim('Last name cannot include space').strict(true).min(2, 'Must be at least 2 characters').max(50, 'Must be at most 50 characters').required('Enter last name'),
        title: yup.string().min(2, 'Must be at least 2 characters').max(50, 'Must be at most 50 characters'),
        primary_email: yup.string().email('Please enter valid email address').min(2, 'Must be at least 2 characters').max(50, 'Must be at most 50 characters'),
        phone1: yup.string().max(25, 'Phone must be at most 25 characters'),
    })

    //======Start:: Write a code for handle add and edit contact detail========//
    const handleSubmit = async (values, onSubmitProps) => {
        const data = {
            salutation: values.salutation,
            first_name: values.first_name,
            last_name: values.last_name,
            title: values.title,
            primary_email: values.primary_email,
            phone1: values.phone1,
            account_id: account_id,
            ...(contactID && {
                id: contactID,
                account_id: selectedAccount || ''
            })
        }

        showLoader()
        await axiosInstance.post(`/api/contact/${contactID ? 'update' : 'store'}`, data).then(response => {
            if (response.status === 200) {
                hideLoader()
                showSnackbar(response.data.message, 'success')
                onClose()
                handleReloadFunc()
                handleReloadParentFunc()
            }
        }).then(json => {

        }).catch(error => {
            if (error.response) {
                hideLoader()
                onSubmitProps.setSubmitting(false)
                if (error.response.status === 422 || error.response.data.validation_errors) {
                    const errors = error.response.data.validation_errors;
                    Object.keys(errors).forEach(key => {
                        onSubmitProps.setFieldError(key, errors[key][0]);
                    });
                } else {
                    showSnackbar(error.response.data.message, 'error')
                }
            }
        });
    }
    //======End:: Write a code for handle add and edit contact detail========//

    //======Start:: Write a code for handle edit contact detail========//
    useEffect(() => {
        if (contactID) {
            function fetchData() {
                showLoader();
                getContactDetail();
            }
            fetchData();
        }
    }, [contactID]);


    const getContactDetail = async () => {
        showLoader();
        await axiosInstance.get(`api/contact/edit/${contactID}`).then(response => {
            if (response.status === 200) {
                setContactData(response?.data?.data?.record);
                setSelectedAccount(response.data.data.selectedAccount)
                hideLoader();
            }
        }).then((json) => { })
            .catch((error) => {
                if (error.response) {
                    hideLoader();
                    if (error.response.status === 400) {
                        showSnackbar(error.response.data.message, "warning");
                        Navigate("/deal");
                    }
                }
            });
    }
    //======End:: Write a code for handle edit contact detail========//
    return (
        <>
            <Dialog onClose={onClose} open={open}>
                <div className="dialog-title">
                    <h2>Create New Contact</h2>
                    <Tooltip title="Close">
                        <button className="icon-button dialog-close" onClick={onClose}>
                            <Icon path={mdiClose} color={'currentColor'} size={1} />
                        </button>
                    </Tooltip>
                </div>
                <Formik
                    initialValues={{
                        salutation: contactData?.salutation || 'Mr',
                        first_name: contactData.first_name || '',
                        last_name: contactData.last_name || '',
                        title: contactData.title || '',
                        primary_email: contactData.primary_email || '',
                        error_list: [],
                        phone1: contactData?.phone1 || '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {props => {
                        const {
                            touched,
                            errors,
                            values,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                        } = props;
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={1.5}>
                                    <Grid item xs="auto">
                                        <TextField
                                            select
                                            className="no-label"
                                            value={values.salutation}
                                            name="salutation"
                                            variant="filled"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.salutation && touched.salutation}
                                            helperText={(errors.salutation && touched.salutation) && errors.salutation}

                                        >
                                            {Object.entries(salutationList).map(([key, value], index) => (
                                                <MenuItem key={index} value={key}>
                                                    {value}
                                                </MenuItem>
                                            ))}

                                        </TextField>
                                    </Grid>
                                    <Grid item xs>
                                        <Grid container spacing={1.5}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    label="First Name"
                                                    variant="filled"
                                                    name="first_name"
                                                    value={values.first_name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={errors.first_name && touched.first_name}
                                                    helperText={(errors.first_name && touched.first_name) && errors.first_name}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    label="Last Name"
                                                    variant="filled"
                                                    name="last_name"
                                                    value={values.last_name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={errors.last_name && touched.last_name}
                                                    helperText={(errors.last_name && touched.last_name) && errors.last_name}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <TextField
                                    label="Title"
                                    variant="filled"
                                    name="title"
                                    value={values.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.title && touched.title}
                                    helperText={(errors.title && touched.title) && errors.title}
                                />

                                <Grid container spacing={1.5}>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Email"
                                            variant="filled"
                                            name="primary_email"
                                            value={values.primary_email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.primary_email && touched.primary_email}
                                            helperText={(errors.primary_email && touched.primary_email) && errors.primary_email}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Phone"
                                            variant="filled"
                                            name="phone1"
                                            value={values.phone1}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.phone1 && touched.phone1}
                                            helperText={(errors.phone1 && touched.phone1) && errors.phone1}
                                        />
                                    </Grid>
                                </Grid>

                                <Stack direction="row" spacing={1.5} justifyContent={'flex-end'}>
                                    <Button type="submit">{contactID ? 'Update' : 'Create'}</Button>
                                    <Button color="secondary" onClick={onClose}>Cancel</Button>
                                </Stack>
                            </form>
                        );
                    }}
                </Formik>
            </Dialog>
        </>
    );
}

export default CreateNewContactDialog;